import { FC, SVGAttributes } from 'react';

const Freeze: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12 2V18M12 22V18M12 18L15 21M12 18L9 21M15 3L12 6L9 3"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M3.34101 7.00042L6.80511 9.00042M6.80511 9.00042L17.1974 15.0004M6.80511 9.00042L5.70703 4.90234M6.80511 9.00042L2.70703 10.0985M17.1974 15.0004L20.6615 17.0004M17.1974 15.0004L21.2955 13.9023M17.1974 15.0004L18.2955 19.0985"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M20.6615 7.00042L17.1974 9.00042M17.1974 9.00042L6.80511 15.0004M17.1974 9.00042L18.2955 4.90234M17.1974 9.00042L21.2955 10.0985M6.80511 15.0004L3.34101 17.0004M6.80511 15.0004L2.70703 13.9023M6.80511 15.0004L5.70703 19.0985"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
};

export default Freeze;
